(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-quote-list"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dm-quote-list')) {
  customElements.define('dm-quote-list', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.text = JSON.parse(this.querySelector('.dm-ql__strings').textContent);
      this.items = [];
      this.counter = 0;
      this.events = new AbortController();
      const on = (element, event, callback) => element.addEventListener(event, callback, {signal:this.events.signal});
      this.searchForm = this.querySelector('.dm-ql__search');
      this.searchInput = this.searchForm.querySelector('input');
      this.results = this.querySelector('.dm-ql__results');
      this.searchStatus = this.querySelector('.dm-ql__search-status');
      this.selection = this.querySelector('.dm-ql__selection');
      this.variant = this.querySelector('.dm-ql__variant');
      this.quantity = this.querySelector('.dm-ql__quantity');
      this.list = this.querySelector('.dm-ql__items');
      this.status = this.querySelector('.dm-ql__action-status');
      this.summary = this.querySelector('.dm-ql__summary');
      this.submit = this.querySelector('.dm-ql__submit');
      this.storageKey = 'dm-quote-list-v1';
      if (this.querySelector('[data-success]')) {
        try { sessionStorage.removeItem(this.storageKey); } catch {}
        this.querySelector('[data-success]').focus();
        return;
      }
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
        if (saved && Date.now()-saved.time < 86400000 && Array.isArray(saved.items)) this.items = saved.items.filter(item => /^\d+$/.test(item.id) && typeof item.title==='string' && typeof item.option==='string' && typeof item.sku==='string' && /^[a-zA-Z0-9_-]+$/.test(item.handle) && Number.isInteger(item.quantity) && item.quantity>0 && item.quantity<=999).slice(0,10);
      } catch {}
      this.querySelector('.dm-ql__workspace').hidden = false;
      on(this.searchForm,'submit',event => {event.preventDefault();this.search();});
      on(this.variant,'change',() => this.updateAvailability());
      on(this.querySelector('.dm-ql__add'),'click',() => this.add());
      on(this.submit.closest('form'),'submit',event => {
        if (!this.items.length) {event.preventDefault();this.status.textContent=this.text.list_required;this.searchInput.focus();}
        else if ([...this.list.querySelectorAll('input')].some(input => !input.reportValidity())) event.preventDefault();
        else this.writeSummary();
      });
      this.renderList();
    }
    disconnectedCallback() {this.events?.abort();this.searchRequest?.abort();this.productRequest?.abort();this.ready=false;}
    element(tag,text,className) {const element=document.createElement(tag);if(text!==undefined)element.textContent=text;if(className)element.className=className;return element;}
    optionLabel(title) {return title==='Default Title'?this.text.default_option:title;}
    async search() {
      const query=this.searchInput.value.trim();
      if(query.length<2)return;
      this.searchRequest?.abort();this.productRequest?.abort();this.counter++;
      this.searchRequest=new AbortController();const request=this.searchRequest;
      this.results.replaceChildren();this.results.hidden=false;this.selection.hidden=true;this.product=null;
      this.searchStatus.textContent=this.text.searching;
      const url=new URL(this.dataset.search+'.json',location.origin);
      url.search=new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'8','resources[options][fields]':'title,product_type,variants.title,variants.sku,vendor'}).toString();
      try {
        const response=await fetch(url,{signal:request.signal});if(!response.ok)throw new Error('search');
        const data=await response.json();if(request!==this.searchRequest)return;
        const products=data.resources?.results?.products || [];
        this.searchStatus.textContent=products.length?this.text.results+products.length:this.text.no_results;
        for(const product of products) {
          if(!/^[a-zA-Z0-9_-]+$/.test(product.handle))continue;
          const item=this.element('li');
          const picture=this.element('span');
          if(product.image){const image=this.element('img');const src=new URL(product.image,location.origin);if(src.protocol==='https:'){src.searchParams.set('width','96');image.src=src.href;image.alt='';image.width=48;image.height=48;image.loading='lazy';picture.append(image);}}
          const content=this.element('div');content.append(this.element('strong',product.title));
          const button=this.element('button',this.text.choose);button.type='button';button.setAttribute('aria-label',this.text.choose+': '+product.title);button.addEventListener('click',()=>this.choose(product.handle),{signal:this.events.signal});content.append(button);item.append(picture,content);this.results.append(item);
        }
      } catch(error) {if(error.name!=='AbortError' && request===this.searchRequest)this.searchStatus.textContent=this.text.search_error;}
    }
    async choose(handle) {
      this.productRequest?.abort();this.productRequest=new AbortController();const request=this.productRequest;
      const sequence=++this.counter;this.product=null;this.selection.hidden=true;this.searchStatus.textContent=this.text.loading;
      try {
        const response=await fetch(this.dataset.root+'products/'+encodeURIComponent(handle)+'.js',{signal:request.signal});if(!response.ok)throw new Error('product');
        const product=await response.json();if(sequence!==this.counter)return;
        if(!Array.isArray(product.variants)||!product.variants.length)throw new Error('variants');
        this.product=product;this.variant.replaceChildren();
        for(const variant of product.variants){const option=this.element('option',this.optionLabel(variant.title));option.value=String(variant.id);this.variant.append(option);}
        this.querySelector('.dm-ql__product-title').textContent=product.title;
        this.quantity.value='1';this.results.hidden=true;this.selection.hidden=false;this.searchStatus.textContent='';this.updateAvailability();
        this.querySelector('.dm-ql__product-title').focus();
      } catch(error) {if(error.name!=='AbortError' && sequence===this.counter)this.searchStatus.textContent=this.text.selection_error;}
    }
    updateAvailability() {
      const variant=this.product?.variants.find(item=>String(item.id)===this.variant.value);if(!variant)return;
      this.querySelector('.dm-ql__availability').textContent=variant.available?this.text.available:this.text.unavailable;
      this.querySelector('.dm-ql__product-link').href=this.dataset.root+'products/'+encodeURIComponent(this.product.handle)+'?variant='+variant.id;
    }
    add() {
      if(!this.quantity.reportValidity())return;
      const quantity=Number(this.quantity.value);if(!Number.isInteger(quantity)||quantity<1||quantity>999){this.status.textContent=this.text.quantity_error;return;}
      const variant=this.product?.variants.find(item=>String(item.id)===this.variant.value);if(!variant)return;
      const existing=this.items.find(item=>item.id===String(variant.id));
      if(existing){if(existing.quantity+quantity>999){this.status.textContent=this.text.quantity_error;return;}existing.quantity+=quantity;}
      else {if(this.items.length>=10){this.status.textContent=this.text.limit;return;}this.items.push({id:String(variant.id),handle:this.product.handle,title:this.product.title,option:variant.title,sku:variant.sku||'',quantity});}
      this.renderList();this.status.textContent=existing?this.text.merged:this.text.added;
    }
    writeSummary() {
      this.summary.value=this.items.map((item,index)=>[`${index+1}. ${item.title}`,this.text.line_option+': '+this.optionLabel(item.option),this.text.line_quantity+': '+item.quantity,...(item.sku?[this.text.line_sku+': '+item.sku]:[]),this.text.line_link+': '+location.origin+this.dataset.root+'products/'+encodeURIComponent(item.handle)+'?variant='+item.id].join('\n')).join('\n\n');
    }
    renderList() {
      this.list.replaceChildren();this.status.textContent='';
      this.items.forEach((item,index)=>{
        const row=this.element('li');row.append(this.element('strong',item.title),this.element('p',this.optionLabel(item.option)+(item.sku?' · '+item.sku:'')));
        const controls=this.element('div',undefined,'dm-ql__item-controls');const field=this.element('div');const id='dm-ql-item-'+this.dataset.section+'-'+index;
        const label=this.element('label',this.text.quantity);label.htmlFor=id;
        const input=this.element('input');Object.assign(input,{id,type:'number',min:'1',max:'999',step:'1',value:String(item.quantity),inputMode:'numeric'});input.setAttribute('aria-label',this.text.quantity+': '+item.title+' — '+this.optionLabel(item.option));
        input.addEventListener('input',()=>{const value=Number(input.value);const valid=Number.isInteger(value)&&value>=1&&value<=999;input.setCustomValidity(valid?'':this.text.quantity_error);if(!valid)this.status.textContent=this.text.quantity_error;else{item.quantity=value;this.status.textContent='';this.writeSummary();this.updateTotals();this.save();}this.submit.disabled=[...this.list.querySelectorAll('input')].some(field=>!field.validity.valid);},{signal:this.events.signal});
        const remove=this.element('button',this.text.remove);remove.type='button';remove.setAttribute('aria-label',this.text.remove+': '+item.title+' — '+this.optionLabel(item.option));
        remove.addEventListener('click',()=>{this.items.splice(index,1);this.renderList();const next=this.list.querySelector('button');(next||this.searchInput).focus();},{signal:this.events.signal});
        field.append(label,input);controls.append(field,remove);row.append(controls);this.list.append(row);
      });
      this.querySelector('.dm-ql__empty').hidden=this.items.length>0;this.submit.disabled=this.items.length===0;this.writeSummary();this.updateTotals();this.save();
    }
    updateTotals() {this.querySelector('.dm-ql__totals').textContent=this.items.length?this.text.count+this.items.length+' · '+this.text.units+this.items.reduce((sum,item)=>sum+item.quantity,0):'';}
    save() {try{sessionStorage.setItem(this.storageKey,JSON.stringify({time:Date.now(),items:this.items}));}catch{}}
  });
}

  } catch(e) { console.error(e); }
})();
})();
